import { render, staticRenderFns } from "./cardRecord.vue?vue&type=template&id=451c2862&scoped=true&"
import script from "./cardRecord.vue?vue&type=script&lang=js&"
export * from "./cardRecord.vue?vue&type=script&lang=js&"
import style0 from "./cardRecord.vue?vue&type=style&index=0&id=451c2862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c2862",
  null
  
)

export default component.exports